import { BookingRecord } from "@/app/Bookings/GraphQL/bookingRecordQuery";
import { RelocationListItem } from "@/app/Relocations/GraphQL/relocationListQuery";
import { BookingMatchingRelocationsTable } from "@/app/Bookings/Components/BookingMatchingRelocationsTable";
import { useDialog } from "@/lib/Components/Dialog/Hooks/useDialog";
import { BookingChangeRelocationDialog } from "@/app/Bookings/Components/BookingChangeRelocationDialog";
import { Button } from "@/components/catalyst/button";
import { RotateCwIcon } from "lucide-react";
import {
  getMatchingRelocationVariables,
  getSimilarRelocationVariables,
  useMatchingRelocationIds,
} from "@/app/Bookings/Components/FindRelocation/useFindRelocationTables";

export function MatchingRelocationsTable({
  booking,
  onAssign,
}: {
  booking: BookingRecord;
  onAssign?: (relocation: RelocationListItem) => void;
}) {
  return (
    <BookingMatchingRelocationsTable
      bookingId={booking.id}
      onAssign={onAssign}
      title="Matching relocations"
      queryVariables={getMatchingRelocationVariables(booking)}
    />
  );
}

export function SimilarRelocationsTable({
  booking,
  onAssign,
}: {
  booking: BookingRecord;
  onAssign?: (relocation: RelocationListItem) => void;
}) {
  const matchingIds = useMatchingRelocationIds(booking);

  return (
    <BookingMatchingRelocationsTable
      onAssign={onAssign}
      bookingId={booking.id}
      title="Similar relocations"
      queryVariables={getSimilarRelocationVariables(booking, matchingIds)}
    />
  );
}
export function ManualAssignButton({ booking }: { booking: BookingRecord }) {
  const { open } = useDialog(BookingChangeRelocationDialog);

  return (
    <Button
      outline
      LeadingIcon={RotateCwIcon}
      onClick={() => {
        open({
          booking: booking,
          newRelocation: null,
        });
      }}
    >
      Manually assign
    </Button>
  );
}

export function AssignRelocationDialog({
  booking,
}: {
  booking: BookingRecord;
}) {
  const { open } = useDialog(BookingChangeRelocationDialog);

  return (
    <div className="rounded-xl border border-dashed border-zinc-300 bg-zinc-50 p-6 text-center dark:border-white/10 dark:bg-white/5">
      <h2 className="text-base font-semibold leading-6 text-zinc-900 dark:text-white">
        {"Can't"} find the right relocation?
      </h2>
      <p className="mx-auto mt-1 max-w-md text-sm text-zinc-500 dark:text-zinc-400">
        Manually assign a different relocation to this booking by using the
        relocation ID.
      </p>
      <p className="mt-4 flex justify-center">
        <Button
          onClick={() => {
            open({
              booking: booking,
              newRelocation: null,
            });
          }}
          LeadingIcon={RotateCwIcon}
        >
          Change Relocation
        </Button>
      </p>
    </div>
  );
}
